import { render, staticRenderFns } from "./SmartInspection.vue?vue&type=template&id=67d736ba&"
import script from "./SmartInspection.vue?vue&type=script&lang=js&"
export * from "./SmartInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports